import { Link } from "react-router-dom";
import SectionTitle from "@/components/feature/SectionTitle";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <SectionTitle
        align="center"
        eyebrow="内容专题"
        title="六个专题，覆盖娱乐圈的主要话题方向"
        desc="不用在一堆链接里翻找，选一个你想看的专题，直接进入对应的话题列表。"
      />

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => {
          const count = articles.filter((a) => a.categorySlug === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to="/topics"
              className="group flex flex-col overflow-hidden rounded-card border border-background-200 bg-background-50 transition-colors hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full overflow-hidden" style={{ aspectRatio: "16 / 9" }}>
                <img
                  src={cat.cover}
                  alt={`${cat.name}专题封面`}
                  title={`${cat.name} · 黑料在线专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-md bg-background-50/95 text-primary-600">
                  <i className={`${cat.icon} text-lg`} />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{cat.name}</h3>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-label text-secondary-900">
                    {count} 篇
                  </span>
                </div>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-4 flex items-center gap-1 text-sm font-label text-primary-700">
                  进入专题
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}